import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateSpecificationForm from '../../../modules/specifications/components/CreateSpecificationForm';
import { useParams } from 'react-router-dom';

const CreateSpecification = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { slug ,id } = useParams();
    dispatch(
        setBreadCrumbsData({
        links: [{ label: t('create_specification'), path: `/specification-groups/specifications/${slug}/create-specification` }],
        page_title: id ? t('edit_specification') : t('create_specification')
        })
    );

    return (
        <div>
            <CreateSpecificationForm />
        </div>
    );
};

export default CreateSpecification;
